export var DeliveryLifecycleStatusEnum;
(function (DeliveryLifecycleStatusEnum) {
    DeliveryLifecycleStatusEnum["PENDING"] = "pending";
    DeliveryLifecycleStatusEnum["SENT"] = "sent";
    DeliveryLifecycleStatusEnum["ERRORED"] = "errored";
    DeliveryLifecycleStatusEnum["SKIPPED"] = "skipped";
    DeliveryLifecycleStatusEnum["CANCELED"] = "canceled";
    DeliveryLifecycleStatusEnum["MERGED"] = "merged";
    DeliveryLifecycleStatusEnum["DELIVERED"] = "delivered";
    DeliveryLifecycleStatusEnum["INTERACTED"] = "interacted";
})(DeliveryLifecycleStatusEnum || (DeliveryLifecycleStatusEnum = {}));
//# sourceMappingURL=delivery-lifecycle-status.enum.js.map